<template>
    <div>
        <!-- Filter Start -->
        <custom-filter
            :getFilterOnStart="true"
            @filterChange="changeFilter"
        ></custom-filter>
        <!-- Filter End -->
        
        <!-- Chart Start -->
         <div class="row mt-4">
            <div class="col">
                <div class="innerBox">
                    <div class="row">
                        <div class="col-md-8">
                            <h5 class="elegant--sub-title">
                                Activation Report
                                <i
                                    class="fas fa-info-circle"
                                    id="activation-report"
                                ></i>
                                <b-popover target="activation-report" triggers="hover" placement="top">
                                    <template #title>Activation Report</template>
                                    <div v-html="tooltip.activation_report"></div>
                                </b-popover>
                            </h5>
                        </div>
                        <div class="col-md-2">
                            <MultiSelect 
                                v-model="filter.oilmaker"
                                :options="options.oilMaker.map(x => x.code)"
                                :custom-label="opt => options.oilMaker.find(x => x.code == opt).title"
                                placeholder="All Oil Makers"
                                class="elegant-multiselect"
                                />
                        </div>
                        <div class="col-md-2">
                            <button
                                class="btn btn-elegant-download"
                                @click="exportExcel(data.activationReportChart, 'Activation Report Oil Maker Download')"
                            >Download Excel <i class="fas fa-download"></i></button>
                        </div>
                    </div>
                    <activation-report-chart
                        v-if='data.activationReportChart'
                        :data="data.activationReportChart"
                        :filter="filter"
                    ></activation-report-chart>
                    <div v-else class="text-center mt-5 mb-5">
                        <h2 class="pt-5 pb-5">Loading...</h2>
                    </div>
                </div>
            </div>
         </div>
        <!-- Chart End -->

        <!-- Table Start -->
        <div class="bg-white shadow box-content mt-5">
            <div class="row">
                <div class="col-md-8">
                    <h5 class="elegant--sub-title">
                        History Report
                        <i
                            class="fas fa-info-circle"
                            id="history-report"
                        ></i>
                        <b-popover target="history-report" triggers="hover" placement="top">
                            <template #title>History Report</template>
                            <div v-html="tooltip.history_report"></div>
                        </b-popover>
                    </h5>
                </div>
            </div>
            <vue-universal-table
                api_url="/api/reports/oilmaker-history"
                :filter="vue_universal_table.filter"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :special_buttons="['exportToXlsx']"
                :process_data="vue_universal_table.process_data"
                :export_config="vue_universal_table.export_config"
                :infinite_scroll="true"

                sort_order="DESC"
                sort_by="scan_date"
            ></vue-universal-table>
        </div>
        <!-- Table End -->
        
    </div>
</template>

<script>
    import qs from 'qs'
    import customFilter from '@/components/filter/customFilter'
    // import highlightStats from './children/HighlightStats'


    import activationReportChart from './children/activationReportChart.vue'


    export default {
        metaInfo : {
            title : 'Report - Oil Maker'
        },
        data () {
            return {
                tooltip : this.$store.state.tooltip.reports,
                filter : {
                    oilmaker : null,
                },
                data : {
                    activationReportChart :null,
                },
                options : {
                    oilMaker : this.$store.getters.getOilMaker,
                },
                vue_universal_table : {
                    export_config : {
                        name : 'Report Oil Maker Download',
                        type : 'xlsx',
                        all : true,
                    },
                    fields : [
                        {title:"Variant", variable:"product_name"},
                        {title:"Volume", variable:"volume"},
                        {title:"Kode QR", variable:"qrcode"},
                        {title:"Status", variable:"status", style_condition : {
                            'ACTIVATE' : 'color:green; font-weight: bold',
                            'DEACTIVATE' : 'color:red; font-weight: bold',
                            'Double Scan' : 'color:orange; font-weight: bold'
                        }},
                        {title:"Oil Maker", variable:"oil_maker"},
                        {title:"Date", variable:"scan_date"},
                    ],
                    filter : {},
                    update : 0,
                    process_data : `
                        for (var i in data) {
                            data[i].product_name = data[i].product_name ? data[i].product_name : '-'
                            data[i].volume = data[i].volume ? data[i].volume = (parseInt(data[i].volume))/1000 + ' Lt' : '-'
                            data[i].qrcode = data[i].qrcode ? data[i].qrcode : '-'
                            data[i].status = data[i].status ? data[i].status : '-'
                            data[i].oil_maker = data[i].oil_maker ? data[i].oil_maker : '-'
                            data[i].scan_date = data[i].scan_date ? data[i].scan_date : '-'
                        }
                    `
                }
            }
        },
        components : {
            customFilter,
            // highlightStats,
            

            activationReportChart,
        },
        mounted () {
            // this.fetchData();
        },
        watch : {
            'filter' : {
                deep : true,
                handler : 'fetchData',
            },
        },
        methods : {
            changeFilter (filter) {
                for (var i in filter) {
                    this.filter[i] = filter[i];
                    this.vue_universal_table.filter[i] = filter[i];
                }

                //Delete unnecessary filter for the table
                delete this.vue_universal_table.filter.filter;
                // console.log(this.filter);
                this.fetchData();
                this.vue_universal_table.update++;
            },
            fetchData () {
                //Reset All Data to null
                for (var i in this.data) this.data[i] = null;
                
                //Remove filter from filter
                // let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                // delete filterlessFilter.filter;

                //Get Activation Report
                this.$http.get(`/api/reports/oilmaker-activity?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                    .then((resp)=>{
                        this.data.activationReportChart = resp.data.data;
                    })
                    .catch((err)=>{console.log(err)});
                }
          }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }
    
    .table td, .table th{
        text-align: center;
    }

    .box-content {
        padding: 20px;
        border-radius: 10px;
    }
</style>